import { render } from "./CustomSlider.vue?vue&type=template&id=09ad04ce&scoped=true"
import script from "./CustomSlider.vue?vue&type=script&lang=js"
export * from "./CustomSlider.vue?vue&type=script&lang=js"

import "./CustomSlider.vue?vue&type=style&index=0&id=09ad04ce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ad04ce"]])

export default __exports__